import { default as UUID } from "node-uuid"
import { SCALAR_TYPES } from "src/libs/scalars"
import { CARD_FIELD_TYPE, CardFiled, ICard, ILandingSection, LANDING_TYPE_CONTENT, PersonalFields, TestinomialContent } from "src/modules/pe-landing-module/data/interfaces"
import Cards from "./Cards"
import Dummy from "./Dummy"

/* Protopia Ecosystem component */
export interface ITestinomialsProps {
   section:ILandingSection
   data: TestinomialContent
} 

// Dictionary for used card fields type 
export const TestinomialsFieldType  = (): any => ({
    iconMedallion: CARD_FIELD_TYPE.MEDALLION,
    icon : CARD_FIELD_TYPE.IMAGE,
    canvas: CARD_FIELD_TYPE.CANVAS,
    avatar : CARD_FIELD_TYPE.IMAGE,
    avatarMedallion :CARD_FIELD_TYPE.MEDALLION,
    user_name : SCALAR_TYPES.TITLE,
    user_description : SCALAR_TYPES.HTML,
    description : SCALAR_TYPES.HTML,
    links : CARD_FIELD_TYPE.PERSONAL_LINKS,
    buttons : CARD_FIELD_TYPE.BUTTONS,
    divider : CARD_FIELD_TYPE.DIVIDER,
    statistic_line: CARD_FIELD_TYPE.STATISTIC_LINE,
    checkbox: CARD_FIELD_TYPE.CHECK_BOX,
    speech_bubble: CARD_FIELD_TYPE.SPEECH_BUBBLE,
    person : CARD_FIELD_TYPE.PERSON,
    order : CARD_FIELD_TYPE.ORDER,
})

const Testinomials = (props: ITestinomialsProps): JSX.Element => {
    const {data, section} = props
    const {order, cards, card_fields} = data
    
    const getCardFields = ( card_fields: PersonalFields ) : CardFiled[] => {
        let arr: any[] = order.map((key: keyof PersonalFields) => { 
            const field: CardFiled = {
                id: UUID.v4(),
                ...card_fields[key],
                type: TestinomialsFieldType()[key],
                pseudonym: key
            }            
            return field
        })
        return arr
    }
    const getCards = (): ICard[] => {
        let arr: [] = cards.map(( card: any, i:number ) => { 
            return {
                i,
                ...card,
                value: order.map((o: string, ii: number) => ({
                    id: o + "-" + i + "-" + ii,
                    ...card[o]
                }))
            }
        }) 
        return arr
    }
    const getData = ( card_fields: PersonalFields ): any => {
        const personalLinkType: any = {
            ...data,
            card_fields: getCardFields( card_fields ),
            cards: getCards()
        }
        return personalLinkType
    } 
    
    return !!Object.keys(order || {}).length
        ?
        <Cards 
            section={section}
            data={ getData( card_fields || {} ) }
        />
        :
        <Dummy {...{  
            ...{
                data: {
                    ...data as any,  
                    type: LANDING_TYPE_CONTENT.TESTINOMIALS,
                    className: ` ${data.className} landing-html-${props.section.id} `
                },
            },
            ...props as any,
        }} />
}
export default Testinomials